import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, SecurityContext } from '@angular/core';
import { Nl2brPipe, SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { IntroductionService } from '../../services/introduction.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-introduction',
    templateUrl: './introduction.component.html',
    host: {
        class: 'block',
    },
    imports: [DatePipe, Nl2brPipe, SanitizePipe, TranslocoDirective],
})
export class IntroductionComponent {
    public readonly introductionService = inject(IntroductionService);

    public readonly securityContext: SecurityContext = SecurityContext.HTML;

    public readonly textCentered = input(false);

    public readonly model = this.introductionService.getModel();
}
